import { TableProps } from '.';
import TableAdvanceView from './components/TableAdvanceView';
import { TableProvider } from './components/TableContext';
import { deriveDefaultProps, warnings } from './components/util';
import './style.components.scss';
import './style.scss';

const Table = (props: TableProps) => {
    const derivedProps = deriveDefaultProps(props);

    warnings(derivedProps);

    return <TableProvider {...derivedProps}>
        <TableAdvanceView basic />
    </TableProvider>
}

export default Table;